<template>
    <v-container fluid grid-list-md>
        <v-layout row wrap>
            <v-flex>
                <h1 class="display-3">Costos</h1>
            </v-flex>
        </v-layout>
        <v-layout wrap row>
            <v-flex xs12 sm12 md3>
                <v-card>
                    <v-toolbar color="primary" dark dense>
                        <v-toolbar-title>Opciones</v-toolbar-title>
                    </v-toolbar>
                    <v-container fluid>
                        <v-layout align-center justify-center row wrap>
                            <v-flex xs12>
                                <tipo-item-select v-model="d.item_tipo_id" @change="limpiar"></tipo-item-select>
                            </v-flex>
                        </v-layout>
                        <v-layout align-center justify-center row wrap>
                            <v-flex xs12>
                                <v-select :items="ubicaciones" v-model="d.ubicacion" label="Ubicación"
                                          @change="traeEstructura"></v-select>
                            </v-flex>
                        </v-layout>
                        <v-layout align-center justify-center row wrap>
                            <v-flex xs12>
                                <empresa-select v-model="d.empresa" @change="traeEstructura"></empresa-select>
                            </v-flex>
                        </v-layout>
                        <v-layout align-center justify-center row wrap v-if="d.item_tipo_id">
                            <v-text-field label="Código" v-model="d.codigo"
                                          @change="setCodigo(d.empresa,d.codigo)"></v-text-field>
                            <!--                            <v-flex xs12 v-else>-->
                            <!--                                <item-select label="Código" v-model="codigoObj" :id.sync="d.codigo" :tipo="d.item_tipo_id" @change="traeEstructura"></item-select>-->
                            <!--                            </v-flex>-->
                        </v-layout>
                    </v-container>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-tooltip top>
                            <v-btn slot="activator" @click="limpiar" color="red" flat dark icon>
                                <v-icon>delete</v-icon>
                            </v-btn>
                            <span>Limpiar datos</span>
                        </v-tooltip>
                        <v-tooltip top>
                            <v-btn slot="activator" @click="descarga" color="orange" flat dark icon>
                                <v-icon>cloud_download</v-icon>
                            </v-btn>
                            <span>Descargar</span>
                        </v-tooltip>
                    </v-card-actions>
                </v-card>
            </v-flex>
            <v-flex v-if="d.item_tipo_id !== 5">
                <v-card class="scroll">
                    <v-card-text>
                        {{ activeTree }}
                        <v-treeview :items="tree" :active.sync="activeTree" activatable transition>
                        </v-treeview>
                    </v-card-text>
                </v-card>
            </v-flex>
            <v-flex xs12 sm12 md3 v-if="d.item_tipo_id === 5">
                <v-card>
                    <v-toolbar color="primary" dark dense>
                        <v-toolbar-title>Estructura del panel</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-tooltip top>
                            <v-btn icon flat @click="setShow()" slot="activator">
                                <v-slide-x-transition mode="out-in">
                                    <v-icon v-text="(show)? 'visibility' : 'visibility_off'"></v-icon>
                                </v-slide-x-transition>
                            </v-btn>
                            <span>{{ (show)? 'Solo mostrar favoritos' : 'Mostrar todo'}}</span>
                        </v-tooltip>
                    </v-toolbar>
                    <v-list dense class="scroll">
                        <template v-for="(i,indx) in posiciones">
                            <v-list-tile @click="seccionActiva = i.id">
                                <v-list-tile-content>
                                    <v-list-tile-title v-html="i.seccion_txt"></v-list-tile-title>
                                    <v-list-tile-sub-title v-html="getDescripcion(indx)"></v-list-tile-sub-title>
                                </v-list-tile-content>
                                <v-list-tile-action>
                                    <v-layout>
                                        <v-flex>
                                            <v-slide-x-transition mode="out-in">
                                                <v-icon v-if="i.sel" color="green">check</v-icon>
                                            </v-slide-x-transition>
                                        </v-flex>
                                        <v-flex>
                                            <v-slide-x-transition mode="out-in">
                                                <v-icon v-if="i.id === seccionActiva" color="orange">arrow_forward_ios
                                                </v-icon>
                                            </v-slide-x-transition>
                                        </v-flex>
                                    </v-layout>
                                </v-list-tile-action>
                            </v-list-tile>
                            <v-divider></v-divider>
                        </template>
                    </v-list>
                </v-card>
            </v-flex>
            <v-flex xs12 sm12 md3 v-if="d.item_tipo_id === 5">
                <template v-for="(seccion, secIndx) in posiciones">
                    <v-card v-if="seccion.id === seccionActiva">
                        <v-toolbar color="primary" dark dense>
                            <v-toolbar-title>{{ seccion.seccion_txt }}</v-toolbar-title>
                            <v-progress-linear class="pagina-progreso" height="4" indeterminate
                                               :active="loading && !showEstructuras"
                                               color="secondary"></v-progress-linear>
                        </v-toolbar>
                        <v-list dense class="scroll">
                            <div v-for="(cod,index) in seccion.codigos" :key="cod.id" v-if="show || cod.fav">
                                <v-hover>
                                    <v-list-tile @click="" slot-scope="{ hover }">
                                        <v-list-tile-avatar v-if="seccion.caract === 'col'"
                                                            :color="cod.avatar"></v-list-tile-avatar>
                                        <v-list-tile-avatar v-if="seccion.caract === 'term'">
                                            <v-img v-if="cod.avatar" :src="cod.avatar"></v-img>
                                            <v-icon v-else>photo_camera</v-icon>
                                        </v-list-tile-avatar>
                                        <v-list-tile-content v-html="cod.desc"
                                                             @click="setVal(secIndx,seccion.codigos,cod.id)"></v-list-tile-content>
                                        <v-list-tile-action>
                                            <v-layout>
                                                <v-flex>
                                                    <v-slide-x-transition>
                                                        <v-btn icon flat color="pink" v-if="hover && !cod.fav"
                                                               @click="setFav(secIndx,index)">
                                                            <v-icon>favorite_border</v-icon>
                                                        </v-btn>
                                                        <v-btn icon flat color="pink" v-if="cod.fav"
                                                               @click="setFav(secIndx,index)">
                                                            <v-icon>favorite</v-icon>
                                                        </v-btn>
                                                    </v-slide-x-transition>
                                                </v-flex>
                                                <v-flex>
                                                    <v-slide-x-transition mode="out-in">
                                                        <v-icon v-if="cod.sel" color="green">check</v-icon>
                                                    </v-slide-x-transition>
                                                </v-flex>
                                            </v-layout>
                                        </v-list-tile-action>
                                    </v-list-tile>
                                </v-hover>
                                <v-divider></v-divider>
                            </div>
                        </v-list>
                    </v-card>
                </template>
            </v-flex>
            <v-flex xs12 sm12 md3 v-if="d.item_tipo_id === 5">
                <v-card v-if="showEstructuras">
                    <v-toolbar color="primary" dark dense>
                        <v-toolbar-title>Estructuras ({{ (Object.keys(estructuras).length > 0)?
                            Object.keys(estructuras).length : 0 }})
                        </v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-tooltip top>
                            <v-btn icon flat slot="activator" @click="setShowBloqueados">
                                <v-slide-x-transition mode="out-in">
                                    <v-icon
                                            v-text="(showBloqueados)? 'fa-unlock' : 'fa-lock'"
                                            :color="(showBloqueados)? 'red' : 'white'"
                                    ></v-icon>
                                </v-slide-x-transition>
                            </v-btn>
                            <span>{{ (showBloqueados)? 'Mostrando bloqueados' : 'Bloqueados ocultos'}}</span>
                        </v-tooltip>
                        <v-progress-linear class="pagina-progreso" height="4" indeterminate :active="loading"
                                           color="secondary"></v-progress-linear>
                    </v-toolbar>
                    <v-list dense class="scroll">
                        <template v-for="e in estructuras">
                            <v-list-tile @click="setCodigo(e.emp,e.G1_COD)" :class="{'red--text':e.B1_MSBLQL === '1'}">
                                <v-list-tile-avatar>
                                    <v-img :src="e.avatar"></v-img>
                                </v-list-tile-avatar>
                                <v-list-tile-content>
                                    <v-list-tile-title v-html="e.G1_COD"></v-list-tile-title>
                                    <v-list-tile-sub-title v-html="e.B1_DESC"></v-list-tile-sub-title>
                                </v-list-tile-content>
                            </v-list-tile>
                            <v-divider></v-divider>
                        </template>
                    </v-list>
                </v-card>
            </v-flex>
        </v-layout>
        <v-layout>
            <v-flex xs12 id="tabla">
                <h3 v-if="mostrarTabla">Producto: {{ d.codigo }}</h3>
                <v-progress-linear :indeterminate="true" :active="loading"></v-progress-linear>
                <v-data-table
                        v-if="mostrarTabla"
                        :headers="headers"
                        :items="items"
                        hide-actions
                        class="elevation-1 animated fadeIn"
                >
                    <template slot="items" slot-scope="props">
                        <td class="text-xs-center">{{ props.item.nivel }}</td>
                        <td>
                            <span v-if="props.item.prod_id">({{ props.item.prod_id }})</span>
                            <b>{{ props.item.title }}</b></td>
                        <td class="text-xs-right">{{ props.item.cant | moneda }}</td>
                        <td class="text-xs-right">{{ props.item.um }}</td>
                        <td class="text-xs-right">{{ props.item.precio | moneda(2) }}</td>
                        <td class="text-xs-right">{{ props.item.incid | moneda }}</td>
                        <td class="text-xs-right">{{ props.item.scrap | moneda }}</td>
                        <td class="text-xs-right"><b>{{ props.item.total | moneda(2)}}</b></td>
                        <td class="text-xs-right">
                            <v-edit-dialog :return-value.sync="props.item.porcent" lazy
                                           class="cuadro-edicion"
                            >
                                <span style="width: 100%">{{ (props.item.porcent)?props.item.porcent : 0 }}</span>
                                <v-text-field
                                        slot="input"
                                        v-model="props.item.porcent"
                                        label="Editar"
                                        single-line
                                        type="number"
                                        hint="Presione Enter para guardar"
                                >
                                </v-text-field>
                            </v-edit-dialog>
                        </td>
                        <td class="text-xs-center">{{ props.item.tipo_costo | tipoCosto }}</td>
                        <td>
                            <v-menu open-on-hover left top offset-y
                                    v-if="props.item.actualizado !== true && props.item.actualizado > 0">
                                <v-icon color="orange" slot="activator">warning</v-icon>
                                <v-card dark>
                                    <v-card-text>El costo fue actualizado hace {{ props.item.actualizado}} dias
                                    </v-card-text>
                                </v-card>
                            </v-menu>
                            <v-menu open-on-hover left top offset-y v-if="props.item.total === 0">
                                <v-icon color="red" slot="activator">info</v-icon>
                                <v-card dark>
                                    <v-card-text>No se encontró costo para este item</v-card-text>
                                </v-card>
                            </v-menu>
                        </td>
                    </template>
                    <template slot="footer" v-if="totalCosto">
                        <td colspan="6" class="text-xs-right">
                            <h3>Total: </h3>
                        </td>
                        <td class="text-xs-right">
                            <h3>{{ totalCosto | moneda(2)}}</h3>
                        </td>
                        <td class="text-xs-right">
                            <h3>{{ porcentTotal | moneda(2)}}</h3>
                        </td>
                    </template>
                </v-data-table>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
    import draggable from 'vuedraggable'
    import filterMoneda from '../../filters/moneda';
    import mixinConfig from '../../mixins/config';
    import tipoItemSelect from '../../components/TipoItemSelect';
    import ItemSelect from '../../components/ItemSelect';
    import EmpresaSelect from '../../components/EmpresaSelect';
    import {mapActions} from 'vuex';
    import saveAs from 'file-saver';

    export default {
        name: "costo2",
        components: {draggable, tipoItemSelect, ItemSelect, EmpresaSelect},
        filters: {
            tipoCosto(v) {
                if (v === 'LP') {
                    return 'Lista de precios'
                } else if (v === 'UE') {
                    return 'Última entrada'
                } else {
                    return '';
                }
            },
            moneda: filterMoneda
        },
        mixins: [mixinConfig],
        data() {
            return {
                loading: false,
                posiciones: [],
                estructuras: [],
                seccionActiva: -1,
                show: true,
                showEstructuras: false,
                showBloqueados: false,
                favs: {},
                mostrarTabla: false,
                codigoObj: {},
                d: {
                    ubicacion: 'B',
                    empresa: 3,
                    item_tipo_id: 5,
                    codigo: ''
                },
                headers: [
                    {text: 'Nivel', value: 'nivel', align: 'center'},
                    {text: 'Producto', value: 'title', align: 'center'},
                    {text: 'Cant', value: 'cant', align: 'center'},
                    {text: 'UM', value: 'um', align: 'center'},
                    {text: 'Precio Unit', value: 'precio', align: 'center'},
                    {text: 'Incid (USD/M2)', value: 'incid', align: 'center'},
                    {text: 'Scrap', value: 'scrap', align: 'center'},
                    {text: 'Total', value: 'total', align: 'center'},
                    {text: '% Variac.', value: '', align: 'center'},
                    {text: 'Tipo de Costo', value: 'tipo_costo', align: 'center'}
                ],
                items: [],
                tree: [],
                activeTree: '',
                ubicaciones: [
                    {text: 'Mendoza', value: 'M'},
                    {text: 'Buenos Aires', value: 'B'},
                ],
            }
        },
        computed: {
            porcentTotal() {
                let total = this.items.reduce((a, b) => {
                    let total = 0;
                    if (b.porcent && b.porcent !== '0' && b.porcent !== 0) {
                        let precioNuevo = parseFloat(b.precio) + ((parseFloat(b.porcent) * parseFloat(b.precio)) / 100);
                        let incid = precioNuevo * parseFloat(b.cant);
                        let totScrap = (incid > 0) ? (parseFloat(b.scrapBase) / 100) * incid : 0;
                        total = incid + totScrap;
                    } else if (b.key === 'IIBB') {// no lo tomo porque es sobre el total
                        total = 0;
                    } else {
                        total = parseFloat(b.total)
                    }
                    return total == null ? a : a + total;
                }, 0);
                return (total * (this.costoOtros / 100)) + total;
            }
        },
        mounted() {
            this.listado();
            this.show = this.$ls.get('costos.show')
        },
        methods: {
            ...mapActions('notif', ['msjShow']),
            limpiar() {
                this.posiciones.forEach(pos => {
                    pos.sel = false;
                    pos.codigos.forEach(cod => {
                        cod.sel = false;
                    });
                    this.seccionActiva = -1;
                    this.showEstructuras = false;
                    this.mostrarTabla = false;
                    this.d.codigo = '';
                });
            },
            setCodigo(emp, codigo) {
                this.d.emp = emp;
                this.d.codigo = codigo;
                this.setSeleccion()
            },
            setSeleccion() {
                this.posiciones.forEach(pos => {
                    let variable = this.d.codigo.substring(pos.desde, pos.desde + pos.cant);
                    pos.codigos.map(codigo => {
                        codigo.sel = (codigo.variable === variable);
                    });
                    pos.sel = true;
                });

                this.traeEstructura();
            },
            validaCodigo() {
                if (!this.d.codigo) {
                    return false;
                }
                // let codigo = '';
                //
                // if (this.d.item_tipo_id !== 5) {
                //     if (!this.codigoObj['micro_id_' + this.d.empresa]) {
                //         this.msjShow({
                //             txt: 'Producto no vinculado o sin referencia a la empresa seleccionada',
                //             tipo: 2
                //         });
                //         return false;
                //     }
                //     codigo = this.codigoObj['micro_id_' + this.d.empresa];
                // } else {
                //     codigo = this.d.codigo;
                // }
                return this.d.codigo;
            },
            traeEstructura() {
                let codigo = this.validaCodigo();
                if (!codigo) {
                    return false;
                }
                this.loading = true;
                this.$http.post('indicadores/costo/estructura', {
                    ubicacion: this.d.ubicacion,
                    empresa: this.d.empresa,
                    item_tipo_id: this.d.item_tipo_id,
                    codigo: codigo
                })
                    .then(r => {
                        this.loading = false;
                        if (r.data.tipo && r.data.tipo === 2) {
                            this.msjShow({txt: r.data.txt, tipo: r.data.tipo});
                        }
                        if (!r.data.d) {
                            return false;
                        }
                        if (this.d.item_tipo_id === 4) {
                            this.tree = r.data.tree;
                        }
                        this.items = r.data.d;
                        this.totalCosto = r.data.totalCosto;
                        this.mostrarTabla = true;
                        this.traeConfig();
                        this.$vuetify.goTo('#tabla', {duration: 2000})
                    }, err => {
                        alert(err);
                        this.loading = false;
                    })
            },
            descarga() {
                let codigo = this.validaCodigo();
                if (!codigo) {
                    return false;
                }
                this.loading = true;
                this.$http({
                    method: 'post',
                    url: 'indicadores/costo/excel-producto',
                    data: {
                        ubicacion: this.d.ubicacion,
                        empresa: this.d.empresa,
                        item_tipo_id: this.d.item_tipo_id,
                        codigo: codigo
                    },
                    headers: {'Content-Type': 'application/json', 'Accept': 'application/vnd.ms-excel'},
                    responseType: "blob"
                })
                    .then((response) => {
                        if (response.data.tipo && response.data.tipo === 2) {
                            this.msjShow(response.data);
                            this.loading = false;
                            return false;
                        }
                        saveAs(response.data, 'costos.xlsx');
                        this.loading = false;
                    })
                    .catch((error) => {
                        alert(error);
                        this.loading = false;
                    });
            },
            traeConfig() {
                this.configGet({nom: 'costoOtros'}, r => {
                    this.costoOtros = r;
                }, err => console.error(err))
            },
            setShow() {
                this.show = !this.show;
                this.$ls.set('costos.show', this.show);
            },
            setShowBloqueados() {
                this.showBloqueados = !this.showBloqueados;
                this.getEstructuras();
            },
            listado() {
                this.$http.post("panel/posiciones")
                    .then(r => {
                        this.posiciones = r.data;
                        this.getFav();
                    });
            },
            setVal(secIndx, arr, id) {
                arr.map(i => {
                    i.sel = (i.id === id) ? !i.sel : false;
                });
                this.posiciones[secIndx].sel = true;
                this.getEstructuras();
            },
            setFav(secIndx, indx) {
                this.posiciones[secIndx].codigos[indx].fav = !this.posiciones[secIndx].codigos[indx].fav;
                let seccion = this.posiciones[secIndx].seccion;
                let variable = this.posiciones[secIndx].codigos[indx].variable;
                this.$http.post('indicadores/costo/favorito', {
                    seccion: seccion,
                    variable: variable,
                    estado: this.posiciones[secIndx].codigos[indx].fav
                })
                    .then(r => {
                        console.log(r)
                    })
                    .catch(err => {
                        console.log(err)
                    })
            },
            getDescripcion(secIndx) {
                let cod = this.posiciones[secIndx].codigos.find(e => {
                    return e.sel;
                });
                return (cod) ? cod.desc : '';
            },
            getEstructuras() {
                this.loading = true;
                let codigo = [];
                for (let i = 0; i < this.posiciones.length; i++) {
                    if (this.posiciones[i].sel) {
                        let cod = this.posiciones[i].codigos.find(e => {
                            return e.sel;
                        });
                        if (cod) {
                            codigo.push({
                                desde: this.posiciones[i].desde,
                                cant: this.posiciones[i].cant,
                                cod: cod.variable
                            })
                        }
                    }
                }
                if (codigo.length === 0) {
                    this.estructuras = [];
                    this.loading = false;
                } else {
                    this.$http.post("panel/estructuras", {codigo: codigo, showBloqueados: this.showBloqueados})
                        .then(r => {
                            this.estructuras = r.data;
                            this.loading = false;
                            this.showEstructuras = true;
                        })
                        .catch(err => {
                            this.loading = false;
                        });
                }

            },
            getFav() {
                this.$http.get('indicadores/costo/favorito')
                    .then(r => {
                        this.favs = r.data;
                        this.favs.forEach(f => {
                            let posIndx = this.posiciones.findIndex(posicion => {
                                return posicion.seccion === f.seccion
                            });
                            let codIndx = this.posiciones[posIndx].codigos.findIndex(codigo => {
                                return (codigo.variable === f.variable);
                            });
                            this.posiciones[posIndx].codigos[codIndx].fav = true;
                        })
                    })
                    .catch(err => {
                        console.log(err)
                    })
            }
        }
    }
</script>
<style scoped>
    table.v-datatable.v-table tbody td,
    table.v-datatable.v-table tfoot td,
    table.v-datatable.v-table thead th {
        padding: 0;
        border-left: 1px solid rgba(0, 0, 0, .12);
        border-right: 1px solid rgba(0, 0, 0, .12);
    }

    .pagina-progreso {
        position: absolute !important;
        margin: 0;
        bottom: 0;
        left: 0;
    }

    .scroll {
        overflow-y: auto;
        max-height: 300px
    }
</style>



// WEBPACK FOOTER //
// resources/assets/js/pages/indicadores/costo2.vue